var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { space } from 'styled-system';
import { css, styled } from "../utils";
var isProgressNumber = function (number) { return number >= 0 && number <= 100; };
var Bar = styled.div(function (_a) {
    var colors = _a.theme.colors, progress = _a.progress, withShadow = _a.withShadow, withOutline = _a.withOutline;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    background-color: white;\n    height: 6px;\n    border-radius: 3px;\n    position: relative;\n    width: 100%;\n    ", "\n    ", "\n\n    &::after {\n      content: '';\n      position: absolute;\n      border-radius: 3px;\n      height: 100%;\n      background: ", ";\n      width: ", "%;\n      transition: width 0.2s;\n    }\n  "], ["\n    background-color: white;\n    height: 6px;\n    border-radius: 3px;\n    position: relative;\n    width: 100%;\n    ", "\n    ", "\n\n    &::after {\n      content: '';\n      position: absolute;\n      border-radius: 3px;\n      height: 100%;\n      background: ", ";\n      width: ", "%;\n      transition: width 0.2s;\n    }\n  "])), withShadow && 'box-shadow: 0 1px 9px 0 rgba(0, 0, 0, 0.1);', withOutline && "border: 1px solid ".concat(colors.primary, ";"), colors.primary, progress);
}, space);
var ProgressBar = function (_a) {
    var progress = _a.progress, withShadow = _a.withShadow, withOutline = _a.withOutline, className = _a.className, props = __rest(_a, ["progress", "withShadow", "withOutline", "className"]);
    if (!isProgressNumber(progress)) {
        throw new Error('Progress has to be between 0 and 100.');
    }
    return (React.createElement(Bar, __assign({}, props, { progress: progress, className: className, withShadow: withShadow, withOutline: withOutline })));
};
export default ProgressBar;
var templateObject_1;
//# sourceMappingURL=ProgressBar.js.map